import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  checkDateRangeValue,
  fileTypeSplit,
  stringFormatting
} from "../../../../helpers/TextHelper.js"
import { DATE_TYPE_ENUM } from "../../../../../constants/StringConstant.js"
import { capitalize } from "@material-ui/core/utils"
import { FileList } from "../../../../../component/index.jsx"
import { countDaysUntil } from "../../../../helpers/Utils.js"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { getCountDownToday } from "../../../../helpers/StringCollection.js"

export function ContractTab({ contractLog, fileUrl, fileName, fileSize, startDate, endDate }) {
  const { t } = useTranslation()
  const getRemainingDays = () => {
    const days = countDaysUntil(endDate, true)
    return (
      <span
        className={`font-weight-bold d-block ${
          days.days <= 0 ? "text-danger" : days.days > 30 ? "text-muted" : "text-warning"
        }`}>
        {getCountDownToday(days.days, t("label_contract_end"))}
      </span>
    )
  }
  return (
    <>
      <RowModule>
        <Card>
          <CardBody>
            {contractLog &&
              contractLog.length > 0 &&
              [...contractLog]
                .sort((a, b) => {
                  const getStart = (x) => x.startDate || x.start_date || x.date || ""
                  return new Date(getStart(b)) - new Date(getStart(a))
                })
                .map((item, index) => {
                  return (
                    <div key={index} className={"log-file align-items-center"}>
                      <div className={"w-full d-flex justify-content-between"}>
                        <div className={"mb-2"}>
                          <div
                            className={`font-weight-bolder h4 d-flex flex-column ${
                              index === 0 ? "text-mtt-black" : "text-mtt-gray"
                            }`}>
                            {item.name}
                          </div>
                          <div className={"font-size-lg text-mtt-gray"}>
                            {timeStampToDate(item.date, DATE_TYPE_ENUM.ISO_DATETIME_STRAP)} |{" "}
                            {capitalize(t("by"))} {item.created_by}
                          </div>
                        </div>
                        {index === 0 && (
                          <div>
                            <div
                              className={"font-size-base line-height-md text-mtt-gray text-nowrap"}>
                              {t("valid_period")} :{" "}
                              {startDate && endDate
                                ? checkDateRangeValue(
                                    timeStampToDate(startDate, DATE_TYPE_ENUM.ISO_DATE_STRAP),
                                    timeStampToDate(endDate, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                                  )
                                : t("not_set")}
                            </div>
                            {endDate && (
                              <div className={"font-size-base text-warning text-right"}>
                                {getRemainingDays()}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {index === 0 && fileUrl && (
                        <FileList
                          view={stringFormatting(fileUrl)}
                          className={"w-full"}
                          name={stringFormatting(fileName)}
                          size={stringFormatting(fileSize)}
                          type={fileTypeSplit(stringFormatting(fileName))}
                          rightComponent={
                            <a className={"link"} onClick={() => window.open(fileUrl, "_blank")}>
                              {t("see")}
                            </a>
                          }
                        />
                      )}
                    </div>
                  )
                })}
          </CardBody>
        </Card>
      </RowModule>
    </>
  )
}
